export class Constants {
    static KEY_DEFAULT_LANGUAGE = 'ob_dl';
    public static KEYUser = 'key_user_fixit_endUser';
    public static KEYGuest = 'key_guest_fixit_endUser';
    public static KEYAbout = 'key_about_fixit_endUser';
    public static KEYToken = 'key_token_fixit_endUser';
    public static KEYAddress = 'key_address_fixit_endUser';
    public static KEYService = 'key_service_fixit_endUser';
    public static KEYSubService = 'key_subService_fixit_endUser';
    public static KEYChats = 'key_chats_fixit_endUser';
    public static KeySettings = 'key_settings_fixit_endUser';
    public static KeyOneSignal = 'key_oneSignal_fixit_endUser';
    public static KeyNotifications = 'key_notifications_fixit_endUser';
    // public static KeyApi = 'https://fixitqatar.com/spadmin/public/api/';
    //public static KeyApi = 'http://127.0.0.1:8000/api/';
    // public static KeyApi = 'http://192.168.0.110:8000/api/';
    public static KeyApi = 'https://fixitqatar.com/mobileapi/public/api/';
}
